<template>
  <div class="flex w-full justify-center px-4">
    <div class="flex max-w-[260px] flex-col items-center text-center">
      <ArchivedIcon class="size-[34px] text-gray-800" />
      <h2 class="mt-6 text-[20px] leading-[20px] font-medium text-gray-800">
        No archived registrations
      </h2>
      <p class="mt-4 text-[14px] leading-[20px] text-gray-600">
        Archived registrations appear here
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ArchivedIcon } from '@dacr/icons'
</script>
